import script from "./autocomplete-results-list.vue?vue&type=script&lang=ts&setup=true"
export * from "./autocomplete-results-list.vue?vue&type=script&lang=ts&setup=true"

import "./autocomplete-results-list.vue?vue&type=style&index=0&id=65c59ea2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65c59ea2"]])

export default __exports__